import { useRegistrationStore } from '../../hooks';
import { CrawlerRegistrationModalView } from '../../components/CrawlerRegistrationModalView';

export const CrawlerRegistrationModal = () => {
  const registrationStore = useRegistrationStore();

  return <CrawlerRegistrationModalView {...registrationStore} />;
};
